import { useEffect, useImperativeHandle, useRef, useState } from 'react';

import Simulator from '../../threejs/simulator';
import { AircraftOverlayHelper } from './interactiveCard.helper';

interface Props {
  ref: React.RefObject<AircraftOverlayHelper.CardContentRef | null>;
  scale?: number;
  autoRotate?: boolean;
}

const AircraftOverlay: React.FC<Props> = ({
  ref,
  scale = 0.6,
  autoRotate = true,
}) => {
  let canvasRef = useRef(null);
  const [simulation, setSimulation] = useState<Simulator>();

  useImperativeHandle(ref, () => ({
    onMove(x: number, y: number) {
      simulation && simulation.onUpdateOffset(x, y);
    },

    onLeave(x: number, y: number) {
      simulation && simulation.onUpdateOffset(0, 0);
    },
  }));

  useEffect(() => {
    return () => {
      if (simulation) {
        simulation.dispose();
      }
    };
  }, [simulation]);

  useEffect(() => {
    if (canvasRef.current)
      setSimulation(
        new Simulator(canvasRef.current, {
          resource: 'plane-transformed.glb',
          autoRotate,
          scale,
          initialRotation: { x: 0.8, y: 2.3, z: 0 },
        })
      );
  }, [autoRotate, canvasRef, scale]);

  return <canvas ref={canvasRef} width={300} height={150} />;
};

export default AircraftOverlay;
